import { cmsAxiosInstanceWithoutHeaders } from 'api/axiosClient'
import { CMS_ACCESS_TOKEN } from 'constants/process'
import { withAuth } from 'hocs/withAuth'
import { withAuthServerSideProps } from 'hocs/withAuth/withAuthServerSideProps'
import dynamic from 'next/dynamic'

const HirePage = dynamic(() =>
  import('containers/HirePage').then((res) => res.HirePage)
)

const getFaqs = async (context) => {
  try {
    const response = (
      await cmsAxiosInstanceWithoutHeaders.get('/faq', {
        headers: {
          Authorization: `Bearer ${CMS_ACCESS_TOKEN}`,
        },
      })
    ).data.data?.attributes?.faq

    if (response) {
      return {
        faqs: response,
        title: 'Fintros | Hire',
        description: 'How Fintros works for employers',
      }
    }
    return { notFound: true }
  } catch (e) {
    console.error('Error fetching faqs: ', e)
    return { notFound: true }
  }
}

export default withAuth(HirePage, {
  LoggedOutComponent: HirePage,
  naiveCheck: true,
})

export const getStaticProps = withAuthServerSideProps(getFaqs)
